/**
 * Whitelist полей паспорта Country Hub (обзор «Общие сведения»).
 * Короткие подписи — без кодов ok20 в UI по умолчанию.
 */
export type PassportFieldDef = {
  fieldKey: string;
  /** Альтернативные ключи (первое непустое значение выигрывает). */
  altKeys?: string[];
  label: string;
};

export const COUNTRY_PASSPORT_FIELDS: PassportFieldDef[] = [
  { fieldKey: "1.1.1.1.", label: "Наименование (RU)" },
  { fieldKey: "1.1.1.2.", label: "Наименование (EN)" },
  { fieldKey: "1.1.2.", label: "Краткое наименование" },
  { fieldKey: "1.1.4.1.", altKeys: ["iso_alpha3"], label: "ISO alpha-3" },
  { fieldKey: "1.2.1.", label: "Столица" },
  { fieldKey: "1.6.1.", label: "Площадь территории" },
];

export function formatPassportValue(raw: unknown, masked?: boolean): string {
  if (masked) return "••••••••";
  if (raw == null) return "—";
  if (typeof raw === "string") {
    const t = raw.trim();
    return t.length ? t : "—";
  }
  if (typeof raw === "number" || typeof raw === "boolean") return String(raw);
  try {
    return JSON.stringify(raw);
  } catch {
    return "—";
  }
}
